module.exports = __webpack_public_path__ + "static/media/presidentcup.ed48e0d4.jpg";